export default {"src":"/_next/static/media/information-review-star.7b16a670.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};